export default "__VITE_ASSET__DOfAwyin__"